import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';

import {
  HelpContent,
  injectIntl,
} from 'components';

const Helper = ({ name }, { isDistributor, isFarmer, tutorials }) => {
  const tutorialKey = isFarmer ? `seller.${name}` : (
    isDistributor ? `distributor.${name}` : `buyer.${name}`
  );
  const helpContent = tutorials[tutorialKey];
  return (
    <HelpContent>
      <Card>
        <CardHeader
          subheader={get(helpContent, 'subTitle')}
          title={get(helpContent, 'title')}
        />
        <CardMedia
          image={get(helpContent, 'imageUrl')}
          style={{
            height: 300,
            overflowY: 'hidden',
          }}
          title={get(helpContent, 'overlayTitle')}
        />
        <CardContent>
          <Typography component="h2">
            {get(helpContent, 'cardTitle')}
          </Typography>
          <Typography>
            {get(helpContent, 'cardSubTitle')}
          </Typography>
          <Typography component="p" paragraph>
            {get(helpContent, 'text')}
          </Typography>
        </CardContent>
      </Card>
    </HelpContent>
  );
};

Helper.propTypes = {
  name: PropTypes.string,
};

Helper.defaultProps = {
  name: '',
};

Helper.contextTypes = {
  isDistributor: PropTypes.bool,
  isFarmer: PropTypes.bool,
  tutorials: PropTypes.shape({}),
};

const wrappedHelper = injectIntl(Helper);
wrappedHelper.displayName = 'Helper';

export default wrappedHelper;
